//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { SubscribeCode } from './models/SubscribeCode';
import { Utilities } from './Utilities';

export class SubscribeCodeClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSubscribeCode: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/subscribe-code/{siren}';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get code
     * @return OK
     */
    async getSubscribeCode(
        siren: string,
    ): Promise<SubscribeCode> {
        const clientRequestUrl = this.baseUrl + this.routes.getSubscribeCode(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscribeCode>(_response, false, []);
    }
}
